import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class OperativeUnitWithTotalAllocationCostDto {
  operativeUnitId: string;

  @Transform(({ value }) => toEuros(value))
  total: number;
}
